import { h, Component } from "preact";
import { Router, route } from "preact-router";

import Header from "./header";
import UpAnchor from "./up-anchor";

// Code-splitting is automated for routes
import Home from "../routes/home";
import AuthorPage from "../routes/author-page";
import TitelsByKeyword from "../routes/titels-by-keyword";
import TitelsByAuthor from "../routes/titels-by-author";
import BookDetail from "../routes/book-detail";
import QuotesByKeyword from "../routes/quotes-by-keyword";
import FilmPage from "../routes/film-page";
import PathographyList from "../routes/pathography-list";
import FilmDetail from "../routes/film-detail";
import ArtistPage from "../routes/artist-page";
import ArtDetail from "../routes/art-detail";
import ArtByKeyword from "../routes/art-by-keyword";
import AboutByAuthor from "../routes/about-by-author";
import WorkDetail from "../routes/work-detail";
import PoetryByArtist from "../routes/poetry-by-author";
import PoetryDetail from "../routes/poetry-detail";
import PoemsByKeyword from "../routes/poems-by-keyword";
import AboutByKeyword from "../routes/about-by-keyword";

// Admin routes
import Admin from "../routes/admin";
import AdminLogin from "../routes/admin/login";
import AdminEditUser from "../routes/admin/users/edit";
import AdminUsers from "../routes/admin/users";
// romans en verhalen
import AdminRomanListLiterature from "../routes/admin/roman/literature";
import AdminRomanEditLiterature from "../routes/admin/roman/literature/edit";
import AdminRomanListKeyword from "../routes/admin/roman/keyword";
import AdminRomanEditKeyword from "../routes/admin/roman/keyword/edit";
import AdminRomanListGenre from "../routes/admin/roman/genre";
import AdminRomanEditGenre from "../routes/admin/roman/genre/edit";
import AdminRomanEditAuthor from "../routes/admin/roman/author/edit";
import AdminRomanListAuthor from "../routes/admin/roman/author";
import AdminRomanEditQuote from "../routes/admin/roman/quote/edit";
import AdminRomanListQuote from "../routes/admin/roman/quote";
import AdminRomanEditComment from "../routes/admin/roman/comment/edit";
import AdminRomanListComment from "../routes/admin/roman/comment";
import AdminRomanEditImage from "../routes/admin/roman/image/edit";
import AdminRomanRemoveImage from "../routes/admin/roman/image/remove";

// ziektebiografie
import AdminPathographyEditLiterature from "../routes/admin/pathography/literature/edit";
import AdminPathographyListLiterature from "../routes/admin/pathography/literature";
import AdminPathographyEditKeyword from "../routes/admin/pathography/keyword/edit";
import AdminPathographyListKeyword from "../routes/admin/pathography/keyword";
//films
import AdminFilmListLiterature from "../routes/admin/film/literature";
import AdminFilmEditLiterature from "../routes/admin/film/literature/edit";
import AdminFilmListKeyword from "../routes/admin/film/keyword";
import AdminFilmEditKeyword from "../routes/admin/film/keyword/edit";
import AdminFilmListGenre from "../routes/admin/film/genre";
import AdminFilmEditGenre from "../routes/admin/film/genre/edit";
import AdminFilmEditAuthor from "../routes/admin/film/author/edit";
import AdminFilmListAuthor from "../routes/admin/film/author";
import AdminFilmEditDirector from "../routes/admin/film/director/edit";
import AdminFilmListDirector from "../routes/admin/film/director";
import AdminFilmEditImage from "../routes/admin/film/image/edit";
import AdminFilmRemoveImage from "../routes/admin/film/image/remove";
//kunst
import AdminArtListLiterature from "../routes/admin/art/literature";
import AdminArtEditLiterature from "../routes/admin/art/literature/edit";
import AdminArtListKeyword from "../routes/admin/art/keyword";
import AdminArtEditKeyword from "../routes/admin/art/keyword/edit";
import AdminArtEditAuthor from "../routes/admin/art/author/edit";
import AdminArtListAuthor from "../routes/admin/art/author";
import AdminArtEditImage from "../routes/admin/art/image/edit";
import AdminArtRemoveImage from "../routes/admin/art/image/remove";
//poezie
import AdminPoetryListLiterature from "../routes/admin/poetry/literature";
import AdminPoetryEditLiterature from "../routes/admin/poetry/literature/edit";
import AdminPoetryListKeyword from "../routes/admin/poetry/keyword";
import AdminPoetryEditKeyword from "../routes/admin/poetry/keyword/edit";
import AdminPoetryEditAuthor from "../routes/admin/poetry/author/edit";
import AdminPoetryListAuthor from "../routes/admin/poetry/author";
import AdminPoetryEditImage from "../routes/admin/poetry/image/edit";
import AdminPoetryRemoveImage from "../routes/admin/poetry/image/remove";
//about
import AdminAboutListLiterature from "../routes/admin/about/literature";
import AdminAboutEditLiterature from "../routes/admin/about/literature/edit";
import AdminAboutEditKeyword from "../routes/admin/about/keyword/edit";
import AdminAboutListKeyword from "../routes/admin/about/keyword";
import AdminAboutEditAuthor from "../routes/admin/about/author/edit";
import AdminAboutListAuthor from "../routes/admin/about/author";
import AdminAboutEditImage from "../routes/admin/about/image/edit";
import AdminAboutRemoveImage from "../routes/admin/about/image/remove";
import AdminAboutListWork from "../routes/admin/about/work";
import AdminAboutEditWork from "../routes/admin/about/work/edit";
import AdminAboutListArticle from "../routes/admin/about/article";
import AdminAboutEditArticle from "../routes/admin/about/article/edit";
import AdminAboutListPdf from "../routes/admin/about/pdf";
import AdminAboutEditPdf from "../routes/admin/about/pdf/edit";
import FilmByGenre from "../routes/film-by-genre";
import RomanByGenre from "../routes/roman-by-genre";

export default class App extends Component {
  /** Gets fired when the route changes.
   *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
   *	@param {string} event.url	The newly routed URL
   */
  handleRoute = e => {
    const { url } = e;

    this.currentUrl = url;

    // just check if there is a token. Token is validated on the backend and returns 401 if it ain't valid
    if (
      this.currentUrl.indexOf("admin") != -1 &&
      this.currentUrl.indexOf("login") == -1
    ) {
      if (
        sessionStorage.getItem("vumc-jwt") == null ||
        sessionStorage.getItem("vumc-profile") == null
      ) {
        route("/admin/login", false);
      }
    }
  };

  render({ langSwitchClick = () => {}, locale }) {
    return (
      <div id="app" class="outer-wrap">
        <div class="background-anchor"></div>
        <Header langSwitchClick={langSwitchClick} locale={locale} />
        <div class="inner-page">
          <Router onChange={this.handleRoute}>
            <Home path="/:lang?" locale={locale} key="0" />
            <AuthorPage
              path=":lang/roman/author/:id"
              endPoint={`/roman/authordetail`}
              key="1"
              locale={locale}
            />
            <RomanByGenre path=":lang/book/bygenre/:id" key="5" />
            <FilmPage path=":lang/film/keyword/:id" key="1" />
            <FilmDetail path=":lang/film/detail/:id" key="2" />
            <FilmByGenre path=":lang/film/bygenre/:id" key="3" />
            <TitelsByKeyword
              path=":lang/roman/keyword/:id"
              endPoint={`/roman/bykeyword`}
              resultPath={`${locale}/book/detail`}
              key="3"
            />
            <PathographyList path=":lang/pathography/keyword/:id" />
            <TitelsByAuthor path=":lang/titels/author/:id" key="4" />
            <QuotesByKeyword path=":lang/quotes/keyword/:id" />
            <ArtistPage path=":lang/artist/detail/:id" />
            <ArtDetail path=":lang/art/detail/:id" key="1" />
            <ArtByKeyword path=":lang/art/bykeyword/:id" key="2" />
            <BookDetail path=":lang/book/detail/:id" />
            <AboutByAuthor path=":lang/about/byauthor/:id" key="1" />
            <AboutByKeyword path=":lang/about/bykeyword/:id" key="2" />
            {/* <AboutDetail path=":lang/about/detail/:id" /> */}
            <WorkDetail path=":lang/work/bykeyword/:id" />
            <PoetryByArtist path=":lang/poetry/byartist/:id" key="1" />
            <PoetryDetail path=":lang/poetry/detail/:id" key="2" />
            <PoemsByKeyword path=":lang/poetry/bykeyword/:id" key="3" />

            <Admin path=":lang/admin/" />
            <AdminLogin path=":lang/admin/login" />
            <AdminEditUser path=":lang/admin/users/:id" />
            <AdminUsers path=":lang/admin/users" />

            <AdminRomanEditLiterature path=":lang/admin/roman/literature/:id" />
            <AdminRomanListLiterature path=":lang/admin/roman/literature" />
            <AdminRomanEditKeyword path=":lang/admin/roman/keyword/:id" />
            <AdminRomanListKeyword path=":lang/admin/roman/keyword" />
            <AdminRomanEditGenre path=":lang/admin/roman/genre/:id" />
            <AdminRomanListGenre path=":lang/admin/roman/genre" />
            <AdminRomanEditAuthor path=":lang/admin/roman/author/:id" />
            <AdminRomanListAuthor path=":lang/admin/roman/author" />
            <AdminRomanEditQuote path=":lang/admin/roman/quote/:id" />
            <AdminRomanListQuote path=":lang/admin/roman/quote" />
            <AdminRomanEditComment path=":lang/admin/roman/comment/:id" />
            <AdminRomanListComment path=":lang/admin/roman/comment" />
            <AdminRomanRemoveImage path=":lang/admin/roman/image/remove" />
            <AdminRomanEditImage path=":lang/admin/roman/image/:id" />

            <AdminPathographyEditLiterature path=":lang/admin/pathography/literature/:id" />
            <AdminPathographyListLiterature path=":lang/admin/pathography/literature" />
            <AdminPathographyEditKeyword path=":lang/admin/pathography/keyword/:id" />
            <AdminPathographyListKeyword path=":lang/admin/pathography/keyword" />

            <AdminFilmEditLiterature path=":lang/admin/film/literature/:id" />
            <AdminFilmListLiterature path=":lang/admin/film/literature" />
            <AdminFilmEditKeyword path=":lang/admin/film/keyword/:id" />
            <AdminFilmListKeyword path=":lang/admin/film/keyword" />
            <AdminFilmEditGenre path=":lang/admin/film/genre/:id" />
            <AdminFilmListGenre path=":lang/admin/film/genre" />
            <AdminFilmEditAuthor path=":lang/admin/film/author/:id" />
            <AdminFilmListAuthor path=":lang/admin/film/author" />
            <AdminFilmEditDirector path=":lang/admin/film/director/:id" />
            <AdminFilmListDirector path=":lang/admin/film/director" />
            <AdminFilmRemoveImage path=":lang/admin/film/image/remove" />
            <AdminFilmEditImage path=":lang/admin/film/image/:id" />

            <AdminArtEditLiterature path=":lang/admin/art/literature/:id" />
            <AdminArtListLiterature path=":lang/admin/art/literature" />
            <AdminArtEditKeyword path=":lang/admin/art/keyword/:id" />
            <AdminArtListKeyword path=":lang/admin/art/keyword" />
            <AdminArtEditAuthor path=":lang/admin/art/author/:id" />
            <AdminArtListAuthor path=":lang/admin/art/author" />
            <AdminArtRemoveImage path=":lang/admin/art/image/remove" />
            <AdminArtEditImage path=":lang/admin/art/image/:id" />

            <AdminAboutEditLiterature path=":lang/admin/about/literature/:id" />
            <AdminAboutListLiterature path=":lang/admin/about/literature" />
            <AdminAboutEditKeyword path=":lang/admin/about/keyword/:id" />
            <AdminAboutListKeyword path=":lang/admin/about/keyword" />
            <AdminAboutEditAuthor path=":lang/admin/about/author/:id" />
            <AdminAboutListAuthor path=":lang/admin/about/author" />
            <AdminAboutRemoveImage path=":lang/admin/about/image/remove" />
            <AdminAboutEditImage path=":lang/admin/about/image/:id" />
            <AdminAboutEditWork path=":lang/admin/about/work/:id" />
            <AdminAboutListWork path=":lang/admin/about/work" />
            <AdminAboutEditArticle path=":lang/admin/about/article/:id" />
            <AdminAboutListArticle path=":lang/admin/about/article" />
            <AdminAboutEditPdf path=":lang/admin/about/pdf/:id" />
            <AdminAboutListPdf path=":lang/admin/about/pdf" />

            <AdminPoetryEditLiterature path=":lang/admin/poetry/literature/:id" />
            <AdminPoetryListLiterature path=":lang/admin/poetry/literature" />
            <AdminPoetryEditKeyword path=":lang/admin/poetry/keyword/:id" />
            <AdminPoetryListKeyword path=":lang/admin/poetry/keyword" />
            <AdminPoetryEditAuthor path=":lang/admin/poetry/author/:id" />
            <AdminPoetryListAuthor path=":lang/admin/poetry/author" />
            <AdminPoetryRemoveImage path=":lang/admin/poetry/image/remove" />
            <AdminPoetryEditImage path=":lang/admin/poetry/image/:id" />
          </Router>
        </div>
        <UpAnchor />
      </div>
    );
  }
}
